import { Config } from '../core/config'
import { model } from "../core/model";
import AppEvent from './appEvent'

const SUSCRIBIRMEMODOCONST = "S";
// ==================================================
// Extrae un parametro de la current url
// ==================================================   
const returnBack = function () {
    const callBack = (model.Window.pagina);
    const urlToRedirect = callBack || Config.defaultRedirectUrl;
    redirect(urlToRedirect);
}

const redirect = function (url) {
    window.location = url;
}


const appendToUrl = (url, key, value) => {
    if ((url).indexOf('?') == -1) {
        url = url + '?';
    }
    else {
        url = url + '&';
    }
    url = url + key + '=' + value;
    return url;
}

const urlBuilder = (url, isNotSuscribe = true ) => {
    if (model.Window.canalVenta && isNotSuscribe) {
        url = appendToUrl(url, 'cv', model.Window.canalVenta);
    }
    if (model.Window.contact && isNotSuscribe) {
        url = appendToUrl(url, 'fc', model.Window.contact);
    }
    if (model.ProductCategory && model.ProductCategory != null && isNotSuscribe) {
        url = appendToUrl(url, 'productCategory', model.ProductCategory);
    }
    if (isNotSuscribe) {
        //temporal para mantener compatibilidad con wall anterior
        url = appendToUrl(url, 'ref', window.btoa(location.href));
    }
    if (model.Window.pagina) {
        url = appendToUrl(url, 'callback', window.btoa(model.Window.pagina));
    }
    
    return url;
}

const redirectToLoginWCombo = function (combo, urlIngresar, campaign = null, skn = null) {
    //redirecciona a login para que vuelva a una pagina de Compra /C/14/?algo... carrito
    let url = Config.urlRedirect + combo + '/';

    url = addCampaign(url, campaign);
    url = addSkn(url, skn);

    url = urlBuilder(url);
    let encode_url = window.btoa(url);
    console.log(AppEvent);
    AppEvent.sendEvent('REDIRECT', window.atob(encode_url));
    if (model.Embed.Mobile) {
        return;
    }

    encode_url = (urlIngresar) ? (urlIngresar + encode_url) : (url);

    if (model.Embed.Article) {
        encode_url = appendToUrl(encode_url, 'article', true);
    }
    console.log('NAVIGATE->', url, encode_url);
    redirect(encode_url);
}

const redirectToCombo = function (combo, campaign = null, skn = null) {
    //redirecciona a una pagina de Compra /C/14/?algo... carrito
    let url = Config.urlRedirect + combo + '/';

    url = addCampaign(url, campaign);
    url = addSkn(url, skn);

    url = urlBuilder(url);
    console.log('NAVIGATE->', url);
    redirect(url);
}

const redirectToLoginWAction = function (modo, combo) {
    let url = "";
    const esSuscribirme = modo.toUpperCase() === SUSCRIBIRMEMODOCONST
    if (esSuscribirme) {
        url = urlBuilder(Config.urlRedirectAccionVolunteer, !esSuscribirme);
    } else {
        url = urlBuilder(Config.urlRedirectWall(modo, combo));
    }

    let encode_url = window.btoa(url);
    AppEvent.sendEvent('REDIRECT', window.atob(encode_url));
    if (model.Embed.Mobile) 
        return;

    encode_url = Config.dominioIngresar + encode_url;

    if (model.Embed.Article) 
        encode_url = appendToUrl(encode_url, 'article', true);
    
    console.log('NAVIGATE->', url, encode_url);
    redirect(encode_url);
}

const redirectToLogin = function () {

    var encode_url = window.btoa(model.Window.location);
    AppEvent.sendEvent('REDIRECT', window.atob(encode_url));
    if (model.Embed.Mobile) {
        return;
    }
    if (model.Embed.Article) {
        encode_url = encode_url + '&article=' + true;
    }
    redirect(Config.dominioIngresarDefault + encode_url);
}

const redirectToWall = function (modo, combo) {
    let url = urlBuilder(Config.urlRedirectWall(modo, combo));
    redirect(url);
}

const addCampaign = (url, campaign) => {
    if (campaign !== null) return appendToUrl(url, 'campaign', campaign);
    else return url;
}

const addSkn = (url, skn) => {
    if (skn !== null) return appendToUrl(url, 'skn', skn);
    else return url;
}

module.exports = {
    redirect,
    returnBack,
    redirectToLoginWCombo,
    redirectToCombo,
    redirectToLoginWAction,
    redirectToLogin,
    redirectToWall
};


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/helpers/url.js